export default __webpack_public_path__ + "static/media/Бор_1л.70693a74.jpg";